import React, { Fragment, useEffect, useState } from 'react';

export const Minimize = (props) => {
    const {isMinimized, onHideSubMenu, customClass} = props;
    return (
        <Fragment>
            <div onClick={(e) => {onHideSubMenu(e)}} className={`${customClass} d-flex align-center cursor-pointer ${!isMinimized ? 'pl-2': ''}`}>
                    <div className="minimize-app-icon">
                    <i className={`split-arrow fi ${!isMinimized ? 'adjust-position fi-br-angle-double-small-left' : 'fi-br-angle-double-small-right '} custom-shadow`}></i>
                    </div>
                </div>
        </Fragment>
    )
}